export const GET_TEASER_LIST_BLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    teaserListBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      heading
      showTeaserText
      listItemsCollection {
        items {
          ... on TeaserBlock {
            sys {
              id
            }
            heading
            text
            ivImage
            globalLinkItem
            link {
              ... on Page {
                slug
                content {
                  __typename
                }
              }
              ... on FileBlock {
                imageVaultFile
                metaData
                __typename
              }  
            }
            linkText
            externalLink
          }
        }
      }
    }
  }
`;
